// Generated by i18n
import { getInitialLanguage, initI18n } from '@bluecodecom/i18n';

export const SUPPORTED_LNGS = [
  'de',
  'en',
  'it',
  'nl',
  'fr',
  'es',
  'el',
  'pt',
  'fi',
  'ga',
  'et',
  'lv',
  'lt',
  'sl',
  'sk',
  'mt',
  'hr',
  'da',
  'hu',
  'is',
  'no',
  'pl',
  'ro',
  'sv',
] as const;

initI18n(
  {},
  {
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LNGS],
    lazyBackend: true,
    interpolation: {
      escapeValue: false,
    },
  },
);
